export default "__VITE_ASSET__M$mI0NL4__"